import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router";
import apiRequest from "../service/api/api.request";
import { observer } from "mobx-react-lite";
import appState from "../service/state/app.state";
import AddBtn_v1 from "../UI/components/AddBtn_v1";
import InputBlockv1 from "../UI/components/InputBlockv1";
import iconSave from "../images/icons/save_red32.png";

import controllerState from "../service/state/controller.state";

export const Home = observer(() => {
  // const [myControllers, setMyControllers] = useState(undefined);
  const [newcontroller, setNewController] = useState(false);
  const [newcontrollerID, setNewControllerID] = useState("");

  const getDate = async () => {
    await apiRequest.getMyContollers();
  };

  useEffect(() => {
    getDate();
  }, []);

  const addNewController = async () => {
    try {
      const res = await apiRequest.addNewController(newcontrollerID);
      if (res) {
        setNewController(false);
        await getDate();
      } else {
        alert("Не удалось сохранить контроллер");
      }
    } catch (e) {
      console.error(e);
    }
  };

  if (!controllerState.controllers) return;
  return (
    <div className="page">
      <div className="container_btn_new_controller">
        <AddBtn_v1
          help="Добавить новый контроллер "
          onClick={() => setNewController(!newcontroller)}
          valueInterface={newcontroller}
        />
      </div>
      {newcontroller ? (
        <div className="container_new_id">
          <InputBlockv1
            value={newcontrollerID}
            setValue={setNewControllerID}
            title="Введите идентификатор контроллера"
            placeholder="6202000a-59a7-4983-88bf-0000201d0093"
          />
          <img
            className="icon_save"
            src={iconSave}
            alt="Сохранить"
            onClick={addNewController}
          />
        </div>
      ) : (
        <></>
      )}
      {controllerState.controllers.length === 0 ? (
        <p className="grey_text">Не добавлено ни одного контроллера</p>
      ) : (
        <ul>
          {controllerState.controllers.map((c) => (
            <Link
              className="item_controller"
              key={c.id}
              to={`/home/${c.id}`}
              state={{
                name_controller: c.name_controller,
                descriptions: c.descriptions,
                validity_date: c.validity_date,
                identifier: c.identifier,
              }}
            >
              {c.name_controller}
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
});
